module.exports = __webpack_public_path__ + "static/the-sixth-extinction-341b35e525740d575fa2eb8ffde14b4a.jpg";